import React from "react";

export const LiptovskyMikulas = (
  <svg
    className="illustration"
    id="b90746aa-ab89-4048-b48f-88833dcede4a"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="888.24409"
    height="478.03289"
    viewBox="0 0 888.24409 478.03289"
  >
    <title>quite_town</title>
    <path
      d="M347.878,687.98355h-2a94,94,0,0,0-188,0h-2a96,96,0,0,1,192,0Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M1043.878,687.98355h-2a94,94,0,1,0-188,0h-2a96,96,0,1,1,192,0Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M808.878,458.98355h-2c0-94.8413-77.15918-172-172-172-94.84131,0-172,77.1587-172,172h-2c0-95.94384,78.05616-174,174-174C730.82229,284.98355,808.878,363.03971,808.878,458.98355Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <circle cx="145.5" cy="39.5" r="39.5" fill="#ff6584" />
    <polygon
      points="153.891 311.384 221.752 230.567 355.171 230.567 436.705 309.983 435.058 311.042 435.646 311.042 435.646 476.227 153.984 476.227 153.984 311.042 153.891 311.384"
      fill="#3f3d56"
    />
    <rect
      x="350.59718"
      y="433.98355"
      width="15.38295"
      height="53.24868"
      transform="translate(560.69936 710.23224) rotate(-180)"
      fill="#3f3d56"
    />
    <polygon
      points="220.694 229.508 304.345 327.581 304.345 476.227 153.984 476.227 153.984 308.924 220.694 229.508"
      fill="#6c63ff"
    />
    <rect
      x="254.30616"
      y="347.0438"
      width="30.70751"
      height="31.3983"
      fill="#3f3d56"
    />
    <rect
      x="254.30616"
      y="389.767"
      width="30.70751"
      height="31.39834"
      fill="#3f3d56"
    />
    <rect
      x="254.30616"
      y="347.0438"
      width="30.70751"
      height="31.3983"
      fill="#fff"
    />
    <rect
      x="254.30616"
      y="389.767"
      width="30.70751"
      height="31.39834"
      fill="#fff"
    />
    <rect
      x="211.83775"
      y="347.0438"
      width="30.70751"
      height="31.3983"
      fill="#3f3d56"
    />
    <rect
      x="211.83775"
      y="389.767"
      width="30.70751"
      height="31.39834"
      fill="#3f3d56"
    />
    <rect
      x="211.83775"
      y="347.0438"
      width="30.70751"
      height="31.3983"
      fill="#fff"
    />
    <rect
      x="211.83775"
      y="389.767"
      width="30.70751"
      height="31.39834"
      fill="#fff"
    />
    <rect
      x="169.36934"
      y="347.0438"
      width="30.70751"
      height="31.3983"
      fill="#3f3d56"
    />
    <rect
      x="169.36934"
      y="389.767"
      width="30.70751"
      height="31.39834"
      fill="#3f3d56"
    />
    <rect
      x="169.36934"
      y="347.0438"
      width="30.70751"
      height="31.3983"
      fill="#fff"
    />
    <rect
      x="169.36934"
      y="389.767"
      width="30.70751"
      height="31.39834"
      fill="#fff"
    />
    <rect x="485" y="40" width="14" height="35" fill="#6c63ff" />
    <rect x="379" y="72" width="119" height="405" fill="#6c63ff" />
    <rect x="498" y="72" width="48" height="405" fill="#3f3d56" />
    <rect x="400.5" y="107" width="18" height="18" fill="#fff" />
    <rect x="429.5" y="107" width="18" height="18" fill="#fff" />
    <rect x="458.5" y="107" width="18" height="18" fill="#fff" />
    <rect x="401" y="148" width="18" height="18" fill="#fff" />
    <rect x="430" y="148" width="18" height="18" fill="#fff" />
    <rect x="459" y="148" width="18" height="18" fill="#fff" />
    <rect x="401.5" y="189" width="18" height="18" fill="#fff" />
    <rect x="430.5" y="189" width="18" height="18" fill="#fff" />
    <rect x="459.5" y="189" width="18" height="18" fill="#fff" />
    <rect x="402" y="230" width="18" height="18" fill="#fff" />
    <rect x="431" y="230" width="18" height="18" fill="#fff" />
    <rect x="460" y="230" width="18" height="18" fill="#fff" />
    <rect x="402.5" y="271" width="18" height="18" fill="#fff" />
    <rect x="431.5" y="271" width="18" height="18" fill="#fff" />
    <rect x="460.5" y="271" width="18" height="18" fill="#fff" />
    <rect x="403" y="312" width="18" height="18" fill="#fff" />
    <rect x="432" y="312" width="18" height="18" fill="#fff" />
    <rect x="461" y="312" width="18" height="18" fill="#fff" />
    <rect x="403.5" y="353" width="18" height="18" fill="#fff" />
    <rect x="432.5" y="353" width="18" height="18" fill="#fff" />
    <rect x="461.5" y="353" width="18" height="18" fill="#fff" />
    <rect x="404" y="394" width="18" height="18" fill="#fff" />
    <rect x="433" y="394" width="18" height="18" fill="#fff" />
    <rect x="433" y="442" width="18" height="34" fill="#fff" />
    <rect x="462" y="394" width="18" height="18" fill="#fff" />
    <rect x="498" y="40" width="8" height="34" fill="#3f3d56" />
    <rect x="635" y="218" width="14" height="20.74371" fill="#6c63ff" />
    <rect x="529" y="236.96568" width="119" height="240.03432" fill="#6c63ff" />
    <rect x="648" y="236.96568" width="48" height="240.03432" fill="#3f3d56" />
    <rect x="552.5" y="271" width="18" height="18" fill="#fff" />
    <rect x="581.5" y="271" width="18" height="18" fill="#fff" />
    <rect x="610.5" y="271" width="18" height="18" fill="#fff" />
    <rect x="553" y="312" width="18" height="18" fill="#fff" />
    <rect x="582" y="312" width="18" height="18" fill="#fff" />
    <rect x="611" y="312" width="18" height="18" fill="#fff" />
    <rect x="553.5" y="353" width="18" height="18" fill="#fff" />
    <rect x="582.5" y="353" width="18" height="18" fill="#fff" />
    <rect x="611.5" y="353" width="18" height="18" fill="#fff" />
    <rect x="554" y="394" width="18" height="18" fill="#fff" />
    <rect x="583" y="394" width="18" height="18" fill="#fff" />
    <rect x="583" y="442" width="18" height="34" fill="#fff" />
    <rect x="612" y="394" width="18" height="18" fill="#fff" />
    <rect x="648" y="218" width="8" height="20.15103" fill="#3f3d56" />
    <rect
      x="0.24409"
      y="475.79217"
      width="888"
      height="2.24072"
      fill="#3f3d56"
    />
    <circle cx="732.65969" cy="404.04057" r="26.04057" fill="#6c63ff" />
    <path
      d="M907.90824,597.63107A26.0426,26.0426,0,0,1,864.517,625.19165a26.04282,26.04282,0,1,0,43.39129-27.56058Z"
      transform="translate(-155.87795 -210.98355)"
      opacity="0.2"
    />
    <polygon
      points="732.731 404.041 732.803 404.041 734.09 477.87 731.372 477.87 732.731 404.041"
      fill="#3f3d56"
    />
    <rect
      x="890.2546"
      y="653.36959"
      width="1.28772"
      height="4.86472"
      transform="translate(900.27893 -649.01245) rotate(62.23413)"
      fill="#3f3d56"
    />
    <circle cx="809.21843" cy="365.59931" r="39.59931" fill="#6c63ff" />
    <path
      d="M994.55282,550.13364a39.6024,39.6024,0,0,1-65.98417,41.91075,39.60273,39.60273,0,1,0,65.98417-41.91075Z"
      transform="translate(-155.87795 -210.98355)"
      opacity="0.2"
    />
    <polygon
      points="809.327 365.599 809.436 365.599 811.394 477.87 807.26 477.87 809.327 365.599"
      fill="#3f3d56"
    />
    <rect
      x="967.70733"
      y="634.89394"
      width="1.95821"
      height="7.39767"
      transform="translate(926.60095 -727.03592) rotate(62.23413)"
      fill="#3f3d56"
    />
    <circle cx="26.65969" cy="403.04057" r="26.04057" fill="#6c63ff" />
    <path
      d="M201.90824,596.63107A26.0426,26.0426,0,0,1,158.517,624.19165a26.04282,26.04282,0,1,0,43.39129-27.56058Z"
      transform="translate(-155.87795 -210.98355)"
      opacity="0.2"
    />
    <polygon
      points="26.731 403.041 26.803 403.041 28.09 476.87 25.372 476.87 26.731 403.041"
      fill="#3f3d56"
    />
    <rect
      x="184.2546"
      y="652.36959"
      width="1.28772"
      height="4.86472"
      transform="translate(522.29096 -24.83639) rotate(62.23413)"
      fill="#3f3d56"
    />
    <path
      d="M762.29138,248.31933l9.20569-7.36279c-7.15149-.789-10.08991,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41888,6.68671A13.93789,13.93789,0,0,0,762.29138,248.31933Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M300.29138,285.31933l9.20569-7.36279c-7.15149-.789-10.08991,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41888,6.68671A13.93789,13.93789,0,0,0,300.29138,285.31933Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M902.29138,323.31933l9.20569-7.36279c-7.15149-.789-10.08991,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41888,6.68671A13.93789,13.93789,0,0,0,902.29138,323.31933Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M376.29138,265.31933l9.20569-7.36279c-7.15149-.789-10.08991,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41888,6.68671A13.93789,13.93789,0,0,0,376.29138,265.31933Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M393.29138,345.31933l9.20569-7.36279c-7.15149-.789-10.08991,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41888,6.68671A13.93789,13.93789,0,0,0,393.29138,345.31933Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M751.29138,387.31933l9.20569-7.36279c-7.15149-.789-10.08991,3.11126-11.29248,6.19836-5.587-2.32-11.66919.72046-11.66919.72046l18.41888,6.68671A13.93789,13.93789,0,0,0,751.29138,387.31933Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <polygon
      points="106 456 44 456 44 458 53.669 458 53.669 477 55.669 477 55.669 458 93.331 458 93.331 477 95.331 477 95.331 458 106 458 106 456"
      fill="#3f3d56"
    />
    <path
      d="M324.878,674.98355a13.91769,13.91769,0,0,0-6.96954,1.86975A14.98176,14.98176,0,0,0,292.878,687.98355h45.94953A13.99046,13.99046,0,0,0,324.878,674.98355Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M561.878,674.98355a13.91769,13.91769,0,0,0-6.96954,1.86975A14.98176,14.98176,0,0,0,529.878,687.98355h45.94953A13.99046,13.99046,0,0,0,561.878,674.98355Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M716.878,674.98355a13.91769,13.91769,0,0,0-6.96954,1.86975A14.98176,14.98176,0,0,0,684.878,687.98355h45.94953A13.99046,13.99046,0,0,0,716.878,674.98355Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M920.878,674.98355a13.91769,13.91769,0,0,0-6.96954,1.86975A14.98176,14.98176,0,0,0,888.878,687.98355h45.94953A13.99046,13.99046,0,0,0,920.878,674.98355Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <path
      d="M1018.878,674.98355a13.91769,13.91769,0,0,0-6.96954,1.86975A14.98176,14.98176,0,0,0,986.878,687.98355h45.94953A13.99046,13.99046,0,0,0,1018.878,674.98355Z"
      transform="translate(-155.87795 -210.98355)"
      fill="#3f3d56"
    />
    <polygon
      points="129 407 113 407 113 423 120.417 423 120.417 476.912 122.417 476.912 122.417 423 129 423 129 407"
      fill="#3f3d56"
    />
    <rect x="44.12205" y="450.01645" width="62" height="2" fill="#3f3d56" />
    <rect x="44.12205" y="445.01645" width="62" height="2" fill="#3f3d56" />
    <rect x="44.12205" y="440.01645" width="62" height="2" fill="#3f3d56" />
  </svg>
);
export const Travel = (
  <svg
    className="illustration"
    id="e0958169-61ce-49c9-8f2a-5e3a81fc50e8"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="886.35125"
    height="491.63114"
    viewBox="0 0 886.35125 491.63114"
  >
    <title>navigator</title>
    <circle cx="232.39589" cy="103.24635" r="50.76267" fill="#ff6584" />
    <path
      d="M548.40633,463.86269H299.37989a5.07941,5.07941,0,0,1-.93059-.07373L416.22735,259.78044a8.24649,8.24649,0,0,1,14.35487,0L509.62607,396.686l3.78685,6.55094Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#3f3d56"
    />
    <polygon
      points="391.582 259.678 306.558 259.678 348.296 199.052 351.3 194.685 352.802 192.502 356.589 199.052 391.582 259.678"
      opacity="0.2"
    />
    <path
      d="M687.06247,463.86269H471.67506l41.73786-60.62578,3.0036-4.36731,54.38818-79.007c3.56567-5.17807,12.14357-5.50052,16.33577-.97665a9.82994,9.82994,0,0,1,.7832.97665Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#3f3d56"
    />
    <circle cx="593.46332" cy="210.81982" r="15.29649" fill="#6c63ff" />
    <polygon
      points="594.938 256.894 591.805 256.894 593.233 208.516 594.938 256.894"
      fill="#3f3d56"
    />
    <polygon
      points="593.509 217.685 596.873 213.031 593.463 218.837 593.095 218.192 593.509 217.685"
      fill="#3f3d56"
    />
    <polygon
      points="593.141 222.384 589.777 217.731 593.187 223.536 593.555 222.891 593.141 222.384"
      fill="#3f3d56"
    />
    <circle cx="733.78005" cy="210.81982" r="15.29649" fill="#6c63ff" />
    <polygon
      points="735.254 256.894 732.121 256.894 733.55 208.516 735.254 256.894"
      fill="#3f3d56"
    />
    <polygon
      points="733.826 217.685 737.19 213.031 733.78 218.837 733.411 218.192 733.826 217.685"
      fill="#3f3d56"
    />
    <polygon
      points="733.458 222.384 730.094 217.731 733.504 223.536 733.872 222.891 733.458 222.384"
      fill="#3f3d56"
    />
    <circle cx="637.77455" cy="188.84646" r="22.59164" fill="#6c63ff" />
    <polygon
      points="639.952 256.894 635.325 256.894 637.434 185.444 639.952 256.894"
      fill="#3f3d56"
    />
    <polygon
      points="637.843 198.985 642.81 192.113 637.775 200.687 637.23 199.734 637.843 198.985"
      fill="#3f3d56"
    />
    <polygon
      points="637.298 205.926 632.331 199.054 637.366 207.627 637.911 206.675 637.298 205.926"
      fill="#3f3d56"
    />
    <circle cx="692.86823" cy="188.84646" r="22.59164" fill="#6c63ff" />
    <polygon
      points="695.046 256.894 690.419 256.894 692.528 185.444 695.046 256.894"
      fill="#3f3d56"
    />
    <polygon
      points="692.936 198.985 697.904 192.113 692.868 200.687 692.324 199.734 692.936 198.985"
      fill="#3f3d56"
    />
    <polygon
      points="692.392 205.926 687.424 199.054 692.46 207.627 693.004 206.675 692.392 205.926"
      fill="#3f3d56"
    />
    <circle cx="549.96899" cy="188.84646" r="22.59164" fill="#6c63ff" />
    <polygon
      points="552.146 256.894 547.519 256.894 549.629 185.444 552.146 256.894"
      fill="#3f3d56"
    />
    <polygon
      points="550.037 198.985 555.004 192.113 549.969 200.687 549.425 199.734 550.037 198.985"
      fill="#3f3d56"
    />
    <polygon
      points="549.493 205.926 544.525 199.054 549.561 207.627 550.105 206.675 549.493 205.926"
      fill="#3f3d56"
    />
    <path
      d="M974.074,695.81557H236.80819a70.734,70.734,0,1,1,0-141.468H972.44164a27.20538,27.20538,0,0,0,0-54.41076H212.32335v-43.5286H972.44164a70.734,70.734,0,1,1,0,141.468H236.80819a27.20538,27.20538,0,1,0,0,54.41076H974.074Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#e6e6e6"
    />
    <rect
      x="82.70435"
      y="272.8999"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="178.46729"
      y="272.8999"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="274.23022"
      y="272.8999"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="369.99316"
      y="272.8999"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="465.75609"
      y="272.8999"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="561.51903"
      y="272.8999"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="657.28196"
      y="272.8999"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="753.04489"
      y="272.8999"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="82.70435"
      y="370.83926"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="178.46729"
      y="370.83926"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="274.23022"
      y="370.83926"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="369.99316"
      y="370.83926"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="465.75609"
      y="370.83926"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="561.51903"
      y="370.83926"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="657.28196"
      y="370.83926"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="753.04489"
      y="370.83926"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="82.70435"
      y="468.77863"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="178.46729"
      y="468.77863"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="274.23022"
      y="468.77863"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="369.99316"
      y="468.77863"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="465.75609"
      y="468.77863"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="561.51903"
      y="468.77863"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="657.28196"
      y="468.77863"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <rect
      x="753.04489"
      y="468.77863"
      width="33.73467"
      height="2.17643"
      fill="#fff"
    />
    <path
      d="M732.01016,298.87947a28.99191,28.99191,0,0,0-6.04507-5.70351h12.62379A21.11412,21.11412,0,0,0,732.01016,298.87947Z"
      transform="translate(-156.82437 -204.18443)"
      fill="none"
    />
    <path
      d="M690.74325,293.176h2.17616c-.46752.32845-.93648.65539-1.38307,1.01036C691.28145,293.84181,691.00932,293.51136,690.74325,293.176Z"
      transform="translate(-156.82437 -204.18443)"
      fill="none"
    />
    <path
      d="M748.69208,290.55856a20.83292,20.83292,0,0,1,10.12924,2.6174H738.58888A20.74188,20.74188,0,0,1,748.69208,290.55856Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#e6e6e6"
    />
    <path
      d="M709.43111,287.94117a28.623,28.623,0,0,1,16.534,5.23479H692.91941A28.61637,28.61637,0,0,1,709.43111,287.94117Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#e6e6e6"
    />
    <path
      d="M487.03606,254.80744a53.65615,53.65615,0,0,1,105.27431-11.3126c.65-.02332,1.29951-.04944,1.95522-.04944a53.66909,53.66909,0,0,1,51.48218,38.53833A37.92036,37.92036,0,0,1,690.74325,293.176h-167.372a36.29323,36.29323,0,0,1-36.37313-37.57718Q487.01422,255.2037,487.03606,254.80744Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#e6e6e6"
    />
    <path
      d="M777.58705,338.05522a28.99214,28.99214,0,0,1,6.04507-5.70351H771.00833A21.11388,21.11388,0,0,1,777.58705,338.05522Z"
      transform="translate(-156.82437 -204.18443)"
      fill="none"
    />
    <path
      d="M818.854,332.35171h-2.17616c.46752.32845.93647.65539,1.38306,1.01036C818.31576,333.01756,818.5879,332.68711,818.854,332.35171Z"
      transform="translate(-156.82437 -204.18443)"
      fill="none"
    />
    <path
      d="M760.90514,329.73431a20.83286,20.83286,0,0,0-10.12924,2.6174h20.23243A20.74171,20.74171,0,0,0,760.90514,329.73431Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#e6e6e6"
    />
    <path
      d="M800.16611,327.11691a28.62293,28.62293,0,0,0-16.534,5.2348h33.04569A28.61635,28.61635,0,0,0,800.16611,327.11691Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#e6e6e6"
    />
    <path
      d="M1022.56115,293.98318a53.65615,53.65615,0,0,0-105.27431-11.31259c-.65-.02333-1.29951-.04945-1.95522-.04945a53.66909,53.66909,0,0,0-51.48218,38.53833A37.92038,37.92038,0,0,0,818.854,332.35171H986.226a36.29324,36.29324,0,0,0,36.37314-37.57719Q1022.583,294.37945,1022.56115,293.98318Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#e6e6e6"
    />
    <rect
      x="910.97675"
      y="662.3144"
      width="19.45264"
      height="3.08772"
      transform="translate(1684.22678 1124.02413) rotate(-179.96937)"
      fill="#3f3d56"
    />
    <path
      d="M770.33154,663.006l4.01354.92846,152.53335.08154,1.37161-3.19572a32.257,32.257,0,0,0,2.37148-17.44193c-.65694-4.4136-2.30315-8.79914-6.04213-10.70394L917.8105,587.59l-84.38886-.151L800.7719,613.77308s-15.40137-.27686-23.7685,10.13972a24.44959,24.44959,0,0,0-5.1143,13.46591l-.33022,5.41878Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#6c63ff"
    />
    <circle cx="647.00933" cy="458.0675" r="18.83509" fill="#3f3d56" />
    <circle cx="647.00933" cy="458.0675" r="9.91321" fill="#ccc" />
    <circle cx="739.94969" cy="458.11718" r="18.83509" fill="#3f3d56" />
    <circle cx="739.94969" cy="458.11718" r="9.91321" fill="#ccc" />
    <polygon
      points="656.92 406.511 702.483 406.53 708.045 406.53 717.435 406.537 717.435 405.852 717.442 397.594 717.449 388.322 711.201 388.322 705.639 388.316 695.787 388.309 690.225 388.309 678.851 388.302 656.92 406.511"
      fill="#fff"
    />
    <polygon
      points="724.849 406.544 748.929 406.557 748.935 401.832 748.935 393.574 748.942 388.342 745.416 388.342 739.854 388.335 724.856 388.329 724.849 406.544"
      fill="#fff"
    />
    <rect
      x="871.16473"
      y="624.30978"
      width="3.08772"
      height="5.86667"
      transform="translate(1588.2574 1050.7682) rotate(-179.96937)"
      fill="#3f3d56"
    />
    <rect
      x="821.61203"
      y="614.55698"
      width="3.08772"
      height="5.86667"
      transform="translate(1284.26173 -409.51982) rotate(90.03063)"
      fill="#3f3d56"
    />
    <path
      d="M817.13838,604.397h.33966a6.45333,6.45333,0,0,1,6.45333,6.45333v0a6.45333,6.45333,0,0,1-6.45333,6.45333h-.33966a0,0,0,0,1,0,0V604.397A0,0,0,0,1,817.13838,604.397Z"
      transform="translate(1483.91874 1017.9547) rotate(-179.96937)"
      fill="#3f3d56"
    />
    <path
      d="M771.55888,642.79749a9.97473,9.97473,0,0,0,5.44452-18.88469,24.44959,24.44959,0,0,0-5.1143,13.46591Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#3f3d56"
    />
    <polygon
      points="705.639 388.316 717.435 405.852 717.442 397.594 711.201 388.322 705.639 388.316"
      fill="#f2f2f2"
    />
    <polygon
      points="739.854 388.335 748.935 401.832 748.935 393.574 745.416 388.342 739.854 388.335"
      fill="#f2f2f2"
    />
    <polygon
      points="690.225 388.309 702.483 406.53 708.045 406.53 695.787 388.309 690.225 388.309"
      fill="#f2f2f2"
    />
    <circle cx="50.0579" cy="260.92953" r="50.0579" fill="#3f3d56" />
    <path
      d="M207.09056,480.18425l-25.05073-25.05073a4.35315,4.35315,0,0,1,6.15628-6.15628L206.674,467.45511l58.96394-67.23927a4.35271,4.35271,0,0,1,6.54523,5.7397Z"
      transform="translate(-156.82437 -204.18443)"
      fill="#6c63ff"
    />
  </svg>
);
export const Student = (
  <svg
    className="illustration"
    id="f1248760-b706-401a-9a88-490bc0db237b"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="654.23657"
    height="682.11354"
    viewBox="0 0 654.23657 682.11354"
  >
    <title>mathematics</title>
    <path
      d="M892.88171,744.55677c0,25.68-138.79,46.5-310,46.5s-310-20.82-310-46.5c0-18.18,69.57-33.93,170.96-41.57,41.81-3.16,89.05-4.93,139.04-4.93,20.55,0,40.63.3,60.05.87C785.40173,703.12678,892.88171,721.95673,892.88171,744.55677Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#3f3d56"
    />
    <ellipse cx="270" cy="630.61354" rx="119" ry="14.5" opacity="0.1" />
    <ellipse cx="269.5" cy="521.11354" rx="112.5" ry="120" fill="#3f3d56" />
    <rect x="235" y="592.11354" width="70" height="64" fill="#6c63ff" />
    <polygon
      points="396.5 607.614 392.5 629.614 418.5 633.614 435.5 623.614 434.5 607.614 396.5 607.614"
      fill="#575a89"
    />
    <path
      d="M538.38171,303.55677s-2,23-7,24,11,41,11,41h24l19-5-9-22s-12-16-3-29S538.38171,303.55677,538.38171,303.55677Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#a0616a"
    />
    <path
      d="M538.38171,303.55677s-2,23-7,24,11,41,11,41h24l19-5-9-22s-12-16-3-29S538.38171,303.55677,538.38171,303.55677Z"
      transform="translate(-272.88171 -108.94323)"
      opacity="0.1"
    />
    <path
      d="M488.38171,479.55677s-26,50-5,60,26,9,26,12-4,2-2,7-4,25,2,37,4,21,4,21,0,1,2,5,3,7,2,9-7,15-1,18,37,5,40,0-3-8,0-11,5-4,3-6-4-27-4-27,5-29,3-33-5-8-3-11,4-2,5-6,3-13,3-13l11-1,26,5s29,32,61,42c0,0,9,9,12,9s3,0,2,2-4,2-2,4,5-1,3,2-4,3-2,5-1,13-1,14-9,95-6,97,45,8,48,0-2-18-2-18,15-120,11-128-18-44-93-67c0,0-21-4-21-7s-2-22-6-23-27-2-27-2l-29,9-40-7Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#2f2e41"
    />
    <path
      d="M523.38171,647.55677l-5,18s-4,29,1,36c3.92739,5.49834,10.93965,12.23063,23.94449,13.4122a16.07115,16.07115,0,0,0,16.77855-11.11774,5.00653,5.00653,0,0,0,.277-1.29446c0-2-3-26-3-26l-5-25-1-7Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#2f2e41"
    />
    <path
      d="M669.38171,733.55677s-5-5-6,0-5,26,2,27,74,11,81,7,20-10,12-13-31-12-31-12-13-17-15-18-13,1-18,5S669.38171,733.55677,669.38171,733.55677Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#2f2e41"
    />
    <circle cx="289.5" cy="184.61354" r="31" fill="#a0616a" />
    <path
      d="M559.38171,363.55677l-12-13-13.30147-26s-9.69853-3-11.69853,2-38,21-38,21,9,84,5,92-11,40-5,43,34,0,43,4,35,4,42-1,9-9,16-6c5.95926,2.554,19.89075-84.761,23.90164-110.781a11.844,11.844,0,0,0-4.90807-11.50971c-8.97276-6.29384-25.13277-17.13965-27.99357-15.70925C572.38171,343.55677,559.38171,363.55677,559.38171,363.55677Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#575a89"
    />
    <path
      d="M602.38171,359.55677h0a11.85952,11.85952,0,0,1,8.91063,10.19577l8.08936,72.80423s-20,43-30,14S602.38171,359.55677,602.38171,359.55677Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#575a89"
    />
    <path
      d="M600.38171,449.55677l22-6s4,28,8,28-14,16-23,14-22-9-23-14,9-26,9-26Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#575a89"
    />
    <path
      d="M538.98,306.92974c2.10792-4.648,1.74193-10.06966,3.48463-14.86653a17.72716,17.72716,0,0,1,26.95315-8.38071c2.24178,1.59841,4.48928,3.84417,7.22559,3.539,2.94671-.32859,5.575-3.61593,8.2842-2.41116,3.00277,1.33533,2.19174,6.71676,5.23391,7.95972,1.6013.65426,3.49355-.35311,4.41715-1.8157a11.2246,11.2246,0,0,0,1.28583-4.97622c.41976-4.26508.79909-8.779-1.05062-12.64493a30.28893,30.28893,0,0,1-2.02829-4.08992,13.99385,13.99385,0,0,1-.38561-4.03439c-.01689-5.01309-.38281-10.24215-2.90568-14.57417-2.79955-4.80711-7.97447-7.881-13.37326-9.22227s-11.055-1.13561-16.59807-.66635c-9.16324.77574-18.71927,2.43858-25.93856,8.135a10.14728,10.14728,0,0,0-2.49336,2.61953,13.525,13.525,0,0,0-1.32811,3.84148,79.44958,79.44958,0,0,1-6.96764,18.27716,39.65627,39.65627,0,0,0-3.59543,7.76544c-.76559,2.75442-.71387,5.89343.8887,8.26085,1.30475,1.92745,3.39065,2.95463,5.02945,4.53044,1.62387,1.56146,2.38368,4.56438,4.18252,5.74673,1.57033,1.03215,3.4513.30356,5.0529,1.39752C536.40966,302.72479,536.55818,305.80443,538.98,306.92974Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#2f2e41"
    />
    <path
      d="M564.38171,378.55677l3-6s44,13,53,25c0,0,22-14,34-12l12,2-37,33-47-4Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#f2f2f2"
    />
    <path
      d="M562.38171,372.55677l-41,57,59,29s5.51572,3,9.75786,0l39.24214-18,37-53-37,19s-4-8-12-4Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#6c63ff"
    />
    <path
      d="M625.38171,473.55677l8-21s18-23,8-34-21,32-21,32Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#a0616a"
    />
    <path
      d="M533.07939,470.20556l17.45624-14.152s27.11-10.865,23.97851-25.39746-34.22053,17.14513-34.22053,17.14513Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#a0616a"
    />
    <path
      d="M489.88171,369.05677h-1s-15.5-18.5-18.5,6.5-13,108,13,111,44.5-12.5,44.5-12.5,19-29,12-29c-3.38691,0-12.59835-1.52116-21-1-8.96272.556-17.01615,3.08078-16.5.5C503.38171,439.55677,517.88171,376.05677,489.88171,369.05677Z"
      transform="translate(-272.88171 -108.94323)"
      opacity="0.1"
    />
    <path
      d="M488.38171,349.55677l-4-2s-16,3-19,28-13,108,13,111,61-4,61-4,7-38,0-38-43,5-42,0S516.38171,356.55677,488.38171,349.55677Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#575a89"
    />
    <polygon
      points="338 353.114 349.027 336.213 356 364.114 338 372.114 338 353.114"
      fill="#575a89"
    />
    <circle cx="111.47314" cy="85.11354" r="27" fill="#f2f2f2" />
    <rect x="79.47314" y="286.11354" width="64" height="64" fill="#f2f2f2" />
    <polygon
      points="372 0 388.199 28.057 404.397 56.114 372 56.114 339.603 56.114 355.801 28.057 372 0"
      fill="#f2f2f2"
    />
    <path
      d="M927.11829,277.17226q-.58078,17.95539-8.74513,28.78352-8.16571,10.82931-19.40145,10.83029-9.15176,0-16.04242-10.59861-6.89283-10.5984-6.892-32.60592,0-4.8648.23169-9.26642.23089-4.40064.57921-8.33968l4.05409-38.108H854.14538Q847.196,290.14515,842.73627,303.871q-4.46013,13.72556-15.11568,13.726a12.78019,12.78019,0,0,1-8.57155-3.59073,12.06434,12.06434,0,0,1-4.0541-9.4983q0-5.326,8.3976-14.884,8.39721-9.55611,9.32434-17.43233l6.94976-54.32423H828.43149a19.9108,19.9108,0,0,0-9.09265,2.25854,17.15586,17.15586,0,0,0-6.54451,5.27024l-4.98084,7.41313H803.7594q5.67412-17.6052,13.95764-26.46706,8.28-8.86106,19.05393-8.861H925.2652v20.38611H895.381q-1.39011,13.89963-2.14289,27.799-.75455,13.89963-.75278,27.9151,0,9.499,4.40162,15.40548,4.40064,5.90738,11.00386,5.90718,4.05312,0,8.51344-3.30132a11.97,11.97,0,0,0,5.03856-8.62908q.34754-2.54667.52109-3.99618.17377-1.44695.174-1.79536Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#6c63ff"
    />
    <path
      d="M927.11829,277.17226q-.58078,17.95539-8.74513,28.78352-8.16571,10.82931-19.40145,10.83029-9.15176,0-16.04242-10.59861-6.89283-10.5984-6.892-32.60592,0-4.8648.23169-9.26642.23089-4.40064.57921-8.33968l4.05409-38.108H854.14538Q847.196,290.14515,842.73627,303.871q-4.46013,13.72556-15.11568,13.726a12.78019,12.78019,0,0,1-8.57155-3.59073,12.06434,12.06434,0,0,1-4.0541-9.4983q0-5.326,8.3976-14.884,8.39721-9.55611,9.32434-17.43233l6.94976-54.32423H828.43149a19.9108,19.9108,0,0,0-9.09265,2.25854,17.15586,17.15586,0,0,0-6.54451,5.27024l-4.98084,7.41313H803.7594q5.67412-17.6052,13.95764-26.46706,8.28-8.86106,19.05393-8.861H925.2652v20.38611H895.381q-1.39011,13.89963-2.14289,27.799-.75455,13.89963-.75278,27.9151,0,9.499,4.40162,15.40548,4.40064,5.90738,11.00386,5.90718,4.05312,0,8.51344-3.30132a11.97,11.97,0,0,0,5.03856-8.62908q.34754-2.54667.52109-3.99618.17377-1.44695.174-1.79536Z"
      transform="translate(-272.88171 -108.94323)"
      opacity="0.1"
    />
    <path
      d="M927.11829,273.55326q-.58078,17.95539-8.74513,28.78352-8.16571,10.82931-19.40145,10.83029-9.15176,0-16.04242-10.5986-6.89283-10.59841-6.892-32.60593,0-4.8648.23169-9.26642.23089-4.40064.57921-8.33967l4.05409-38.10806H854.14538Q847.196,286.52615,842.73627,300.252q-4.46013,13.72557-15.11568,13.726a12.78019,12.78019,0,0,1-8.57155-3.59073,12.06432,12.06432,0,0,1-4.0541-9.49829q0-5.326,8.3976-14.884,8.39721-9.55612,9.32434-17.43233l6.94976-54.32424H828.43149a19.9108,19.9108,0,0,0-9.09265,2.25854,17.15586,17.15586,0,0,0-6.54451,5.27024l-4.98084,7.41314H803.7594q5.67412-17.60522,13.95764-26.46706,8.28-8.86107,19.05393-8.861H925.2652v20.38611H895.381q-1.39011,13.89963-2.14289,27.79906-.75455,13.89962-.75278,27.91509,0,9.499,4.40162,15.40548,4.40064,5.90738,11.00386,5.90718,4.05312,0,8.51344-3.30132a11.97,11.97,0,0,0,5.03856-8.62908q.34754-2.54667.52109-3.99617.17377-1.447.174-1.79537Z"
      transform="translate(-272.88171 -108.94323)"
      fill="#6c63ff"
    />
  </svg>
);
export const Phone = (
  <svg
    className="illustration"
    id="f7bb3db6-0aca-42e3-bcc4-5e9b3a55e19d"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="879.5"
    height="581.35056"
    viewBox="0 0 879.5 581.35056"
  >
    <title>Mobile_application</title>
    <path
      d="M803.25,740.67528q-36.47625-5.71034-70.14288-9.71417L741.75,713.67528c-3-1-16,9-16,9l11-50c-15,2-22,53-22,53l-17-17,8.36835,19.24713c-68.68128-7.21667-127.94678-9.46881-177.76581-8.95227L535.75,704.17528c-3-1-16,9-16,9l11-50c-15,2-22,53-22,53l-17-17,8.8634,20.38586A997.85166,997.85166,0,0,0,398.59082,727.777c7.38153-22.99578,33.15918-45.10174,33.15918-45.10174-19.82056,6.16638-30.13214,16.2124-35.4693,25.5246A401.561,401.561,0,0,1,417.75,569.17528s-40,90-34,150l.76129,10.65808C349.71191,735.26213,332.25,740.67528,332.25,740.67528Z"
      transform="translate(-160.25 -159.32472)"
      fill="#3f3d56"
    />
    <path
      d="M894.92236,616.811a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,894.92236,616.811Zm0-22a10,10,0,1,0,10,10A10.01114,10.01114,0,0,0,894.92236,594.811Z"
      transform="translate(-160.25 -159.32472)"
      fill="#3f3d56"
    />
    <path
      d="M990.75,739.10087H971.00885V719.35972H990.75Zm-18.2226-1.51855h16.70405v-16.704H972.5274Z"
      transform="translate(-160.25 -159.32472)"
      fill="#3f3d56"
    />
    <path
      d="M322.39387,740.181l-13.4651-14.43621L323.365,712.27965l13.46509,14.43621ZM311.075,725.81944l11.39354,12.21526,12.21525-11.39354L323.29028,714.4259Z"
      transform="translate(-160.25 -159.32472)"
      fill="#3f3d56"
    />
    <rect
      x="21.67236"
      y="578.66157"
      width="857.82764"
      height="2"
      fill="#3f3d56"
    />
    <path
      d="M713.725,293.08473v65.68a2.29614,2.29614,0,0,1-2.29,2.29h-1.62989v342.15a35.702,35.702,0,0,1-35.70007,35.7H460.31509a35.69346,35.69346,0,0,1-35.69006-35.7v-330.15h-1.18a1.6176,1.6176,0,0,1-1.62-1.61v-37.38a1.61971,1.61971,0,0,1,1.62-1.62h1.18v-14.08H423.435a1.69647,1.69647,0,0,1-1.68994-1.7v-36.87a1.69432,1.69432,0,0,1,1.68994-1.69H424.625v-19.22H423.415a1.498,1.498,0,0,1-1.5-1.5v-20.12a1.50661,1.50661,0,0,1,1.5-1.51H424.625v-40.74a35.69136,35.69136,0,0,1,35.69006-35.69H674.105a35.69991,35.69991,0,0,1,35.70007,35.69v95.78H711.435A2.29609,2.29609,0,0,1,713.725,293.08473Z"
      transform="translate(-160.25 -159.32472)"
      fill="#3f3d56"
    />
    <rect
      x="379.97864"
      y="18.3068"
      width="39.82343"
      height="8.08642"
      rx="2.54189"
      fill="#e6e8ec"
    />
    <circle cx="430.41006" cy="22.35" r="4.58665" fill="#e6e8ec" />
    <path
      d="M692.71,202.07524v504.09a22.58,22.58,0,0,1-7.96,17.23,22.6419,22.6419,0,0,1-14.69,5.41H465.41a22.58668,22.58668,0,0,1-10.46-2.55,21.15539,21.15539,0,0,1-2.2-1.3,22.66834,22.66834,0,0,1-9.99-18.79v-504.09a22.649,22.649,0,0,1,22.65-22.65h30.63v3.93a18.65015,18.65015,0,0,0,18.65,18.65H618.77a18.65009,18.65009,0,0,0,18.65-18.65v-3.93h32.64A22.64264,22.64264,0,0,1,692.71,202.07524Z"
      transform="translate(-160.25 -159.32472)"
      fill="#6c63ff"
    />
    <path
      d="M692.71,634.00524v72.16a22.58,22.58,0,0,1-7.96,17.23,22.6419,22.6419,0,0,1-14.69,5.41H465.41a22.58668,22.58668,0,0,1-10.46-2.55,21.15539,21.15539,0,0,1-2.2-1.3,22.66834,22.66834,0,0,1-9.99-18.79v-72.13a186.97056,186.97056,0,0,1,249.95-.03Z"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
      opacity="0.3"
    />
    <path
      d="M680.54,726.23528a22.40961,22.40961,0,0,1-10.48,2.57H465.41a22.58668,22.58668,0,0,1-10.46-2.55,122.16129,122.16129,0,0,1,225.59-.02Z"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
      opacity="0.3"
    />
    <path
      d="M636,727.44483A13.56058,13.56058,0,0,1,629.65831,729H505.81957a13.66765,13.66765,0,0,1-6.32958-1.5431A73.92279,73.92279,0,0,1,636,727.44483Z"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
      opacity="0.3"
    />
    <path
      d="M619.7959,374.5752c-20.52881,0-43.05811-3.90918-60.646-17.1001-24.4873-18.36524-54.65674-17.38526-75.65332-13.32813a164.86282,164.86282,0,0,0-40.27441,13.415l-.92481-1.77344a166.95707,166.95707,0,0,1,40.76758-13.59521c21.40918-4.14356,52.19678-5.13379,77.28516,13.68213,46.99951,35.24951,131.15771,3.59033,132.00146,3.26758l.7168,1.86718a242.3548,242.3548,0,0,1-48.70606,11.85694A186.20165,186.20165,0,0,1,619.7959,374.5752Z"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
    />
    <path
      d="M442.75,356.67528s69-16.71229,117,6.16983,133-.16983,133-.16983"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
      opacity="0.3"
    />
    <path
      d="M507.89111,382.63623a131.45576,131.45576,0,0,1-24.82617-2.479A166.95732,166.95732,0,0,1,442.29736,366.562l.92481-1.77344a164.86232,164.86232,0,0,0,40.27441,13.415c20.99561,4.05664,51.16553,5.03711,75.65332-13.32812,25.06641-18.79981,60.17725-18.74707,85.2124-15.39209a242.3552,242.3552,0,0,1,48.70606,11.85693l-.7168,1.86719c-.84472-.32373-85.001-31.9834-132.00146,3.26758C543.898,378.81445,524.99316,382.63623,507.89111,382.63623Z"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
      opacity="0.3"
    />
    <path
      d="M508.231,374.5835c-34.63428,0-65.39063-12.4253-65.852-12.61524l.76172-1.84961c.68457.28223,69.08837,27.89942,116.10009.06446,47.82471-28.31983,132.90576-3.041,133.75928-2.78223l-.58008,1.91406c-.84472-.25586-85.09277-25.28125-132.16064,2.58887C544.19678,371.415,525.71875,374.5835,508.231,374.5835Z"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
      opacity="0.3"
    />
    <path
      d="M442.76,359.50545s68.99,22.88212,116.99,0,132.96-2.16209,132.96-2.16209"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
      opacity="0.3"
    />
    <path
      d="M710.51913,420.72469v29.15278s2.33223,32.65113,15.15945,48.97669c0,0,20.99,29.73584,23.90529,23.32223l-3.59045-21.11522-12.15205-11.5359-6.41362-36.14946-1.74917-32.65112Z"
      transform="translate(-160.25 -159.32472)"
      fill="#ffb8b8"
    />
    <polygon
      points="679.124 524.941 679.124 546.514 661.633 552.928 661.633 527.856 679.124 524.941"
      fill="#ffb8b8"
    />
    <polygon
      points="643.558 522.609 655.219 548.846 638.894 555.843 635.395 530.189 643.558 522.609"
      fill="#ffb8b8"
    />
    <path
      d="M832.96085,480.77943s23.32223,210.48313,14.57639,211.06619-25.65445,11.66112-25.65445,4.08139S808.4725,589.81086,808.4725,589.81086L795.64528,539.085V609.0517l13.41028,79.29559s-12.82723,16.90861-22.15612,6.99667l-19.8239-77.54642S740.838,500.02027,742.00415,490.69138C742.00415,490.69138,802.05889,439.38247,832.96085,480.77943Z"
      transform="translate(-160.25 -159.32472)"
      fill="#2f2e41"
    />
    <path
      d="M828.2964,707.00507s4.66445-9.912,15.15945-3.49833l8.74584,10.495S874.75,732.67528,858.75,736.67528c-16.49131,4.12283-26.37221-.26326-26.37221-.26326s-2.91528-1.74916-5.2475-1.74916-7.57973-4.08139-7.57973-5.24751,1.74917-21.82722,1.74917-21.82722a3.67667,3.67667,0,0,1,4.08139.58305C827.13029,709.92035,828.2964,707.00507,828.2964,707.00507Z"
      transform="translate(-160.25 -159.32472)"
      fill="#2f2e41"
    />
    <path
      d="M793.89611,703.50674s11.07806-8.74584,16.32556,1.16611c0,0,3.304,1.16611,3.69269,0s3.304-1.74917,3.304,4.66444,3.16611,22.41029.25083,22.99334-5.83055,2.33223-5.2475,4.66445-3.16611,2.66111-16.57639,2.07806-13.99334-5.83056-13.99334-5.83056,0-7.57972,3.49833-11.66111S793.89611,703.50674,793.89611,703.50674Z"
      transform="translate(-160.25 -159.32472)"
      fill="#2f2e41"
    />
    <path
      d="M772.32305,321.6052s-2.91528,21.57307,15.7425,29.15279-41.397,32.65113-47.22752,18.07473,1.16612-19.24084,1.16612-19.24084,5.83055-5.83056.58305-21.57306Z"
      transform="translate(-160.25 -159.32472)"
      fill="#ffb8b8"
    />
    <circle cx="593.41526" cy="151.78548" r="25.65445" fill="#ffb8b8" />
    <path
      d="M783.40111,357.75466s-17.49168,9.32889-34.40029,2.33223-16.32557,23.32223-16.32557,23.32223l8.74584,22.73917,60.6378-5.83056-4.08139-34.98334Z"
      transform="translate(-160.25 -159.32472)"
      fill="#f2f2f2"
    />
    <path
      d="M774.71069,337.80432a21.16638,21.16638,0,0,1,14.521,11.20451l27.98668,8.74583,6.99667,9.91195-8.16278,71.71586s15.15945,14.57639,15.15945,22.73918,18.65778,36.14945,9.32889,32.65112-26.23751-15.74251-26.23751-15.74251-42.56307,1.74917-55.97335,13.41029-18.65779,8.16278-18.65779,8.16278-13.99334-60.6378-14.57639-69.9667-16.90862-65.30224-16.90862-65.30224l29.15279-16.32556,7.42538-8.42509,20.5613,32.91343L783.98416,350.758S774.7661,343.50843,774.71069,337.80432Z"
      transform="translate(-160.25 -159.32472)"
      fill="#3f3d56"
    />
    <path
      d="M832.96085,412.5619l3.49833,18.65779s15.74251,58.30558,13.41028,78.12947c0,0,1.74917,44.31224-8.16278,39.06474s-4.66444-37.31557-4.66444-37.31557L823.0489,453.37581l-7.57973-33.81724Z"
      transform="translate(-160.25 -159.32472)"
      fill="#ffb8b8"
    />
    <path
      d="M818.38445,364.16828l5.83056,3.49833s22.15612,46.06141,16.90862,49.55974S813.137,428.30441,813.137,428.30441Z"
      transform="translate(-160.25 -159.32472)"
      fill="#3f3d56"
    />
    <polygon
      points="561.93 206.01 548.228 205.718 545.022 211.257 549.103 267.814 570.093 272.478 561.93 206.01"
      fill="#3f3d56"
    />
    <path
      d="M774.55608,289.41318l4.62409-1.68149s-9.6685-9.66851-23.12045-8.82773l3.78344-3.78338s-9.24818-3.36292-17.65558,5.46481c-4.4196,4.64055-9.53315,10.09526-12.72091,16.23994h-4.95208l2.06681,4.13363-7.23384,4.13362,7.42483-.7425a20.85851,20.85851,0,0,0,.70227,10.70563l1.68143,4.624s6.726-13.45182,6.726-15.13331v4.2037s4.62409-3.78332,4.62409-6.30552l2.52221,2.94259,1.2611-4.62409,15.5537,4.62409-2.52221-3.78331,9.66851,1.26111-3.78344-4.62409s10.92961,5.4648,11.35006,10.08889,3.306,10.65165,3.306,10.65165l3.49833-4.08139S786.7468,295.7187,774.55608,289.41318Z"
      transform="translate(-160.25 -159.32472)"
      fill="#2f2e41"
    />
    <ellipse
      cx="614.98833"
      cy="152.07701"
      rx="2.0407"
      ry="5.2475"
      fill="#ffb8b8"
    />
    <path
      d="M201.884,706.3411c12.42842,23.049,38.806,32.94351,38.806,32.94351s6.22712-27.47543-6.2013-50.52448-38.806-32.9435-38.806-32.9435S189.45559,683.29206,201.884,706.3411Z"
      transform="translate(-160.25 -159.32472)"
      fill="#3f3d56"
    />
    <path
      d="M210.42653,698.75813c22.43841,13.49969,31.08016,40.3138,31.08016,40.3138s-27.73812,4.92679-50.17653-8.57291S160.25,690.18522,160.25,690.18522,187.98811,685.25844,210.42653,698.75813Z"
      transform="translate(-160.25 -159.32472)"
      fill="#6c63ff"
    />
    <path
      d="M442.76,356.67528s68.99-36,116.99,0,132.96,3.40157,132.96,3.40157"
      transform="translate(-160.25 -159.32472)"
      fill="#fff"
      opacity="0.3"
    />
    <circle cx="407.75" cy="552.67528" r="11" fill="#fff" />
  </svg>
);
export const MindfulLife = (
  <svg
    className="illustration"
    id="b037a0bb-7117-46ab-9d3c-e50125615789"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="883.7815"
    height="672.25367"
    viewBox="0 0 883.7815 672.25367"
  >
    <rect
      x="0.2185"
      y="606.99638"
      width="883.56299"
      height="65.25729"
      fill="#e6e6e6"
    />
    <polygon
      points="882.556 607.051 0 607.051 0 604.87 882.951 604.87 882.556 607.051"
      fill="#3f3d56"
    />
    <path
      d="M851.298,365.06194v193.1823H348.92048V365.06194A251.19094,251.19094,0,0,1,585.60763,114.28746q7.19385-.41944,14.50162-.4143c2.776,0,5.54167.04141,8.28664.145A250.32942,250.32942,0,0,1,777.723,187.44814c1.357,1.35693,2.6932,2.72423,4.0294,4.11227A251.03573,251.03573,0,0,1,851.298,365.06194Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#e6e6e6"
    />
    <path
      d="M608.39589,114.0182v444.226H585.60763V114.28746q7.19385-.41944,14.50162-.4143C602.88527,113.87316,605.65092,113.91457,608.39589,114.0182Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#fff"
    />
    <path
      d="M801.07064,214.34867H399.14786a251.9462,251.9462,0,0,1,19.31826-22.78826H781.75239A251.94772,251.94772,0,0,1,801.07064,214.34867Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#fff"
    />
    <rect
      x="476.90748"
      y="165.7328"
      width="178.04883"
      height="301.42653"
      fill="#fff"
    />
    <rect
      x="512.06564"
      y="216.65602"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="555.45634"
      y="216.65602"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="598.84704"
      y="216.65602"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="512.81376"
      y="278.00149"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="556.20446"
      y="278.00149"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="599.59516"
      y="278.00149"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="513.56187"
      y="339.34697"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="556.95257"
      y="339.34697"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="600.34327"
      y="339.34697"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="514.30999"
      y="400.69244"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="557.70069"
      y="400.69244"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="601.09139"
      y="400.69244"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="514.30999"
      y="400.69244"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="557.70069"
      y="400.69244"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <rect
      x="601.09139"
      y="400.69244"
      width="26.93216"
      height="26.93216"
      fill="#e6e6e6"
    />
    <circle cx="250.52809" cy="345.96177" r="37.11924" fill="#fff" />
    <polygon
      points="250.63 345.962 250.732 345.962 252.568 451.201 248.693 451.201 250.63 345.962"
      fill="#fff"
    />
    <rect
      x="411.08477"
      y="514.49403"
      width="1.83557"
      height="6.93436"
      transform="translate(520.28041 -201.77318) rotate(62.23413)"
      fill="#fff"
    />
    <circle cx="359.65787" cy="291.16612" r="56.44638" fill="#fff" />
    <polygon
      points="359.813 291.166 359.968 291.166 362.759 451.201 356.867 451.201 359.813 291.166"
      fill="#fff"
    />
    <rect
      x="521.48886"
      y="488.15814"
      width="2.7913"
      height="10.54493"
      transform="translate(557.80082 -312.99083) rotate(62.23413)"
      fill="#fff"
    />
    <path
      d="M401.34412,351.13985l9.53553-7.6266c-7.40773-.81727-10.45143,3.22274-11.69709,6.42045-5.78722-2.40307-12.0873.74628-12.0873.74628l19.07883,6.92629A14.43734,14.43734,0,0,0,401.34412,351.13985Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#fff"
    />
    <path
      d="M501.81963,288.99005l9.53553-7.6266c-7.40773-.81727-10.45143,3.22274-11.69709,6.42045-5.78722-2.40307-12.0873.74628-12.0873.74628l19.07884,6.92629A14.43742,14.43742,0,0,0,501.81963,288.99005Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#fff"
    />
    <path
      d="M463.49392,348.03236l9.53553-7.6266c-7.40773-.81727-10.45143,3.22274-11.69709,6.42045-5.78722-2.40307-12.0873.74628-12.0873.74628l19.07884,6.92629A14.43742,14.43742,0,0,0,463.49392,348.03236Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#fff"
    />
    <rect
      x="164.39756"
      y="421.58281"
      width="555.20488"
      height="45.57652"
      fill="#e6e6e6"
    />
    <path
      d="M239.5822,654.09443s-112.306-51.70031-72.853-87.55226S239.5822,654.09443,239.5822,654.09443Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#e6e6e6"
    />
    <path
      d="M237.62748,666.1582s-51.62-169.6065,24.39237-161.49519S237.62748,666.1582,237.62748,666.1582Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#e6e6e6"
    />
    <path
      d="M199.99079,651.11615l2.16658,28.37159.03437.49006a130.35307,130.35307,0,0,0,.67063,13.26586c2.94031,28.939,15.57857,42.12751,30.349,42.12751s26.85842-13.18852,29.79874-42.12751a130.356,130.356,0,0,0,.67062-13.26586l.01721-.3955.00856-.09456,2.17518-28.37159Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#e6e6e6"
    />
    <path
      d="M263.70649,679.48774l-.00856.09456-.01721.3955a130.356,130.356,0,0,1-.67062,13.26586H202.86237a130.35307,130.35307,0,0,1-.67063-13.26586l-.03437-.49006Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#fff"
    />
    <path
      d="M991.00534,654.09443s-112.306-51.70031-72.853-87.55226S991.00534,654.09443,991.00534,654.09443Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#e6e6e6"
    />
    <path
      d="M989.05061,666.1582s-51.62-169.6065,24.39237-161.49519S989.05061,666.1582,989.05061,666.1582Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#e6e6e6"
    />
    <path
      d="M951.41393,651.11615l2.16658,28.37159.03437.49006a130.35311,130.35311,0,0,0,.67062,13.26586c2.94032,28.939,15.57858,42.12751,30.349,42.12751s26.85843-13.18852,29.79874-42.12751a130.35307,130.35307,0,0,0,.67063-13.26586l.01721-.3955.00855-.09456,2.17518-28.37159Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#e6e6e6"
    />
    <path
      d="M1015.12962,679.48774l-.00855.09456-.01721.3955a130.35307,130.35307,0,0,1-.67063,13.26586H954.2855a130.35311,130.35311,0,0,1-.67062-13.26586l-.03437-.49006Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#fff"
    />
    <path
      d="M841.89151,756.80505l-7.36292.8647c-5.81584,3.50648-12.642,4.82649-20.20218,4.55778a6.0584,6.0584,0,0,1-5.132-3.14495h0a6.004,6.004,0,0,1,3.91692-8.70765l5.59465-1.3031,13.49993-13.2034,8.14424-14.73959,11.83011,1.35673,2.46276,18.722h0A14.49192,14.49192,0,0,1,841.89151,756.80505Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#ffb8b8"
    />
    <path
      d="M727.21733,747.33326l-7.21645,1.698c-5.37845,4.14629-12.00974,6.23546-19.55132,6.82989a6.0584,6.0584,0,0,1-5.45694-2.53974h0a6.004,6.004,0,0,1,2.89929-9.09723l5.40974-1.93205,11.90765-14.65557L721.6211,712.065h11.90765l4.57987,18.31946h0A14.49193,14.49193,0,0,1,727.21733,747.33326Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#ffb8b8"
    />
    <path
      d="M721.30136,713.10082l13.46579,2.07166,21.23452-107.2084,36.772-62.66772,44.54069,182.30608,16.57328,3.10749c-1.85841-102.66356,7.21225-231.91222-13.46579-247.56337l-90.11721,10.3583L710.94306,599.15952Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#2f2e41"
    />
    <circle cx="628.4494" cy="178.68068" r="31.0749" fill="#ffb8b8" />
    <polygon
      points="671.954 226.329 634.664 232.544 625.342 199.397 652.273 191.111 671.954 226.329"
      fill="#ffb8b8"
    />
    <path
      d="M845.601,487.28988l-99.43968,9.32247c7.972-27.7204,15.276-55.34331,9.32247-82.8664-7.56022-24.57156-.26306-39.18354,19.68077-50.75567l13.46579-30.03907,36.25405-4.14332,0,0A78.25619,78.25619,0,0,1,835.9919,380.558C830.82605,419.7362,832.2211,456.09141,845.601,487.28988Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#6c63ff"
    />
    <path
      d="M785.859,255.85269c-10.37095,2.36941-22.17487,5.72663-22.83677,8.84705-10.66833,2.68829-18.72067,9.12766-20.36486,18.94463a5.8793,5.8793,0,0,0,5.89829,6.81817c5.80171-.07473,14.51125-.6304,20.26246-3.03248,16.70684,10.7648,19.51113,38.763,12.21507,57.82087l11.48124-1.0524,11.87807-34.77172,3.03391,33.40489,26.20007-3.46416-3.37468-42.59722a63.46522,63.46522,0,0,0-9.96667-28.14221,23.96606,23.96606,0,0,0-1.87524-2.42946A33.29986,33.29986,0,0,0,785.859,255.85269Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#2f2e41"
    />
    <path
      d="M720.0549,767.48915a3.64951,3.64951,0,0,0,3.58967,4.05234l11.65269.11981a2.48493,2.48493,0,0,0,2.312-2.47891h0a2.48494,2.48494,0,0,0-1.562-2.30721l-3.438-1.37518-5-7h-4a18.32116,18.32116,0,0,0-3.55216,8.96941l-.00219.01974Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#ffb8b8"
    />
    <path
      d="M692.1636,767.48915a3.64951,3.64951,0,0,1-3.58967,4.05234l-11.65269.11981a2.48493,2.48493,0,0,1-2.312-2.47891h0a2.48493,2.48493,0,0,1,1.56206-2.30721L679.60925,765.5l5-7h4a18.32106,18.32106,0,0,1,3.55216,8.96941l.00219.01974Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#ffb8b8"
    />
    <polygon
      points="525.5 644.627 531.5 644.627 552.5 553.627 563.5 645.627 570.5 645.627 580 527.127 531.5 526.627 525.5 644.627"
      fill="#3f3d56"
    />
    <path
      d="M656.60925,591.5h8v-19l1.81991-3.63981a5.18356,5.18356,0,0,0-3.84813-7.44145h0a5.18358,5.18358,0,0,0-5.97177,5.1233V591.5Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#ffb8b8"
    />
    <circle cx="546" cy="412.12684" r="18.5" fill="#ffb8b8" />
    <rect
      x="696.60925"
      y="535.5"
      width="19"
      height="22"
      transform="translate(1254.10925 979.12684) rotate(-180)"
      fill="#ffb8b8"
    />
    <path
      d="M687.60925,643.5c16.81763,10.37839,34.59827,9.36365,53,1l-4-93-21-1-22,3-11,9Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#6c63ff"
    />
    <polygon
      points="509.5 496.627 531.5 479.627 524.5 448.627 511.5 472.627 507.5 468.627 495.5 477.627 509.5 496.627"
      fill="#6c63ff"
    />
    <path
      d="M765.26522,553.097l-6.99717,3.87809-9.21047-16.61828-3.35622-2.30132a5.18357,5.18357,0,0,1-.24158-8.37407h0a5.18357,5.18357,0,0,1,7.70676,1.58618l2.8882,5.21112Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#ffb8b8"
    />
    <polygon
      points="568 467.127 594.551 453.032 608.5 445.627 610.5 433.627 601.5 424.627 590.5 431.627 591.5 439.627 578.5 437.627 568 467.127"
      fill="#6c63ff"
    />
    <circle cx="550" cy="405.12684" r="22" fill="#2f2e41" />
    <circle cx="562" cy="380.12684" r="10" fill="#2f2e41" />
    <path
      d="M719.6243,502.36044a9.99733,9.99733,0,0,0,12.83441-14.57A9.99422,9.99422,0,1,1,718.238,501.47266,10.02019,10.02019,0,0,0,719.6243,502.36044Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#2f2e41"
    />
    <path
      d="M781.3795,518.36478l.68709,24.048a13.11173,13.11173,0,0,1-11.80171,13.42112h0a13.11172,13.11172,0,
0,1-13.96224-16.46762l5.39612-19.96565,15.53745-84.93806-1.03583-49.71984,33.14656-1.03583-6.215,55.93482Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#ffb8b8"
    />
    <path
      d="M811.41857,388.886a52.381,52.381,0,0,0-37.28988,0l2.07166-41.43322a16.57327,16.57327,0,0,1,16.57327-16.57326h0a16.57326,16.57326,0,0,1,16.57326,16.57326Z"
      transform="translate(-158.10925 -113.87316)"
      fill="#6c63ff"
    />
  </svg>
);
